export class Analytics {
  totalEncounters: number;
  averageTime: number;
  ratioSuccess: number;
  ratioFailed: number;
  ratioAdjudicated: number;
}
